import baseUrl from "../config/baseUrl";

const editUser = async ({
  token,
  user_id,
  id,
  name,
  description,
  badge,
  bgColor,
}) => {
  try {
    const response = await fetch(
      `${baseUrl}/DMS/api/update_registercategory/${id}`,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: new URLSearchParams({
          name,
          description,
          badge,
          bg_color: bgColor,
        }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default editUser;
